import React from 'react';
import PropTypes from 'prop-types';
import {inject, observer} from 'mobx-react';
import {withRouter} from 'react-router';

import autobind from 'autobind-decorator';
import {withI18n} from 'spa/Components/Context';

import './basket-items-list.less';

@withRouter
@inject(({
  store: {
    notifications,
    tracker,
  },
}) => (
  {
    notifications,
    tracker,
  }
))
@observer
@withI18n
class BasketItemsList extends React.Component {
  static propTypes = {
    itemsList: PropTypes.shape({
      iconUrl: PropTypes.string,
      map: PropTypes.func,
      specialityName: PropTypes.string,
      subtitle: PropTypes.string,
    }).isRequired,
    onClickEdit: PropTypes.func.isRequired,
  }

  render() {
    const {i18n} = this.context;
    const {itemsList, onClickEdit} = this.props;

    return (
      <div className="basket-items-list">
        <ul className="basket-items-list__container">
          {itemsList && itemsList.map((item, index) => (
            <li
              className="basket-items-list__row"
              key={`basket-items-list-element-${index}`}
              style={{
                backgroundImage: item.iconUrl ? `url(${item.iconUrl})` : 'none',
              }}
            >
              <div className="basket-items-list__row-content-wrapper">
                <div className="basket-items-list__row-info-container">
                  <h3 className="basket-items-list__row-title">
                    {item.specialityName}
                  </h3>
                  <p className="basket-items-list__row-sub-title">
                    {item.subtitle}
                  </p>
                </div>
                <div className="basket-items-list__row-button-container">
                  <button
                    className="basket-items-list__row-button"
                    data-item-position={index}
                    data-qa="basket-item-edit-button"
                    onClick={onClickEdit}
                  >
                    {i18n._x('Edit', 'Basket edit button')}
                  </button>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    );
  }
}

export default BasketItemsList;



// WEBPACK FOOTER //
// ./spa/Pages/Booking/Basket/BasketItemsList.jsx